import { render, staticRenderFns } from "./merchant-info.vue?vue&type=template&id=57dd4e6b&scoped=true"
import script from "./merchant-info.vue?vue&type=script&lang=js"
export * from "./merchant-info.vue?vue&type=script&lang=js"
import style0 from "./merchant-info.vue?vue&type=style&index=0&id=57dd4e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd4e6b",
  null
  
)

export default component.exports